import { Box, Button } from '@mui/material';
import type { GridLayout } from '../../store/flashbackStore/dashboardStore.ts';

interface Props {
  value: GridLayout;
  onChange: (layout: GridLayout) => void;
}

const LAYOUTS: GridLayout[] = ['1x1', '2x2', '3x3', '4x4'];

export function LayoutSwitcher({ value, onChange }: Props): JSX.Element {
  return (
    <Box role="radiogroup" aria-label="Grid layout" sx={{ display: 'inline-flex', gap: 0.5 }}>
      {LAYOUTS.map((opt) => {
        const selected = value === opt;
        return (
          <Button
            key={opt}
            role="radio"
            aria-checked={selected}
            type="button"
            variant="outlined"
            size="small"
            disableRipple
            onClick={() => onChange(opt)}
            sx={{
              minWidth: 44,
              height: 36,
              borderRadius: '8px',
              textTransform: 'none',
              fontFamily: 'Roboto, sans-serif',
              fontSize: '13px',
              fontWeight: 500,
              borderColor: selected ? '#2932E5' : '#E0E0E0',
              backgroundColor: selected ? 'rgba(41, 50, 229, 0.12)' : '#FFFFFF',
              color: selected ? '#2932E5' : '#757575',
              '&:hover': {
                borderColor: selected ? '#2932E5' : '#BDBDBD',
                backgroundColor: selected ? 'rgba(41, 50, 229, 0.16)' : '#FAFAFA',
              },
            }}
          >
            {opt}
          </Button>
        );
      })}
    </Box>
  );
}
